var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.67365C1 1.74806 1.74806 1 2.67365 1H6.96137C7.6003 1 8.16871 1.36032 8.45533 1.92255L8.45703 1.92587L9.19356 3.3989H17.0192C17.9448 3.3989 18.6928 4.14696 18.6928 5.07255V8.26045C18.6928 8.74769 18.3034 9.13712 17.8162 9.13712C17.3289 9.13712 16.9395 8.74769 16.9395 8.26045V5.15225H9.14508C8.50621 5.15225 7.93777 4.79208 7.65112 4.22979L7.64942 4.22646L6.91289 2.75334H2.75334V14.5486H8.25247C8.73972 14.5486 9.12914 14.938 9.12914 15.4252C9.12914 15.9125 8.73972 16.3019 8.25247 16.3019H2.67365C1.74806 16.3019 1 15.5538 1 14.6283V2.67365Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8277 15.8941C20.0603 15.7003 20.1948 15.4132 20.1948 15.1105V15.1005C20.1948 14.8364 20.0899 14.5831 19.9031 14.3964C19.5451 14.0384 18.9755 14.0061 18.5792 14.3212L16.8838 15.6698L16.3558 15.1416C15.9683 14.7453 15.3347 14.7408 14.9387 15.1248C14.5426 15.509 14.5278 16.1428 14.9124 16.5422L15.6679 17.3417C15.6772 17.3516 15.687 17.3612 15.6972 17.3702L16.5292 18.1121C16.706 18.2698 16.9716 18.2742 17.1536 18.1226L19.8277 15.8941Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2618 10.5637C14.0927 10.5637 11.5236 13.1328 11.5236 16.3019C11.5236 19.471 14.0927 22.0401 17.2618 22.0401C20.4309 22.0401 23 19.471 23 16.3019C23 13.1328 20.4309 10.5637 17.2618 10.5637ZM13.6488 16.3019C13.6488 14.3065 15.2664 12.689 17.2618 12.689C19.2572 12.689 20.8747 14.3065 20.8747 16.3019C20.8747 18.2973 19.2572 19.9149 17.2618 19.9149C15.2664 19.9149 13.6488 18.2973 13.6488 16.3019Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFile);
export default __webpack_public_path__ + "static/media/folder-file.ad5ea3be173080873ffd6a552604bef3.svg";
export { ForwardRef as ReactComponent };